<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联商机" hasFeedback>
              <a-select
                :disabled="!isEdit"
                allowClear
                placeholder="请选择关联商机"
                @change="marketChange"
                v-decorator="['marketId', { rules: [{ required: false, message: '请选择关联商机！' }] }]"
              >
                <a-select-option v-for="(item, index) in marketList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称" hasFeedback>
              <a-input
                placeholder="请输入项目名称"
                id="name"
                autoComplete="off"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入项目名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目简称" hasFeedback>
              <a-input
                placeholder="请输入项目简称"
                id="shortName"
                autoComplete="off"
                :disabled="!isEdit"
                v-decorator="['shortName', { rules: [{ required: true, message: '请输入项目简称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="招标单位" hasFeedback>
              <a-select
                placeholder="请选择招标单位"
                id="proprietorId"
                allowClear
                :disabled="!isEdit"
                v-decorator="['proprietorId', { rules: [{ required: true, message: '请选择招标单位！' }] }]"
              >
                <a-select-option v-for="(item, index) in proprietorList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目经理" hasFeedback>
              <a-select
                placeholder="请选择项目经理"
                id="projectManager"
                allowClear
                :disabled="!isEdit"
                v-decorator="['projectManager', { rules: [{ required: true, message: '请选择项目经理！' }] }]"
              >
                <a-select-option v-for="(item, index) in projectManagerList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商务经理" hasFeedback>
              <a-select
                placeholder="请选择商务经理"
                id="businessManager"
                allowClear
                :disabled="!isEdit"
                v-decorator="['businessManager', { rules: [{ required: true, message: '请选择商务经理！' }] }]"
              >
                <a-select-option v-for="(item, index) in businessManagerList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="中标时间" hasFeedback>
              <a-date-picker
                style="width: 100%"
                placeholder="请选择中标时间"
                id="winningTime"
                :disabled="!isEdit"
                v-decorator="['winningTime', { rules: [{ required: true, message: '请选择中标时间！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="中标价格" hasFeedback>
              <a-input
                prefix="￥"
                style="width: 100%"
                placeholder="请输入中标价格"
                id="winningPrice"
                autoComplete="off"
                :disabled="!isEdit"
                v-decorator="['winningPrice', { rules: [{ required: true, message: '请输入中标价格！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目类型" hasFeedback>
              <a-select
                placeholder="请选择项目类型"
                id="type"
                allowClear
                :disabled="!isEdit"
                v-decorator="['type', { rules: [{ required: true, message: '请选择项目类型！' }] }]"
              >
                <a-select-option v-for="(item, index) in projectTypeList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                <!-- <a-select-option :value="1">纯软件</a-select-option>
                <a-select-option :value="2">项目集成</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目进度" hasFeedback>
              <a-select
                placeholder="请选择项目进度"
                id="progress"
                allowClear
                :disabled="!isEdit"
                v-decorator="['progress', { rules: [{ required: true, message: '请选择项目进度！' }] }]"
              >
                <a-select-option :value="1">需求调研</a-select-option>
                <a-select-option :value="2">概要设计</a-select-option>
                <a-select-option :value="3">详细设计</a-select-option>
                <a-select-option :value="4">开发实施</a-select-option>
                <a-select-option :value="5">测试调优</a-select-option>
                <a-select-option :value="6">试运行</a-select-option>
                <a-select-option :value="7">质保期</a-select-option>
                <a-select-option :value="8">出质保</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" style="margin-top: 10px; text-align: right">
            <a-button
              type="primary"
              html-type="submit"
              style="margin-right:10px;"
              v-if="this.type !== this.$sysInfo.MODAL_VIEW"
            >提交</a-button>
            <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import moment from 'moment'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { insertProject, updateProject } from '@/api/project'
import { getMarketsList } from '@/api/markets.js'
import { getUserList } from '@/api/roleList'
import { mapGetters } from 'vuex'
// import { addressOptions } from '@/utils/proviceData.js'
export default {
  name: 'EditProject',
  mounted () {},
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    // marketList () {
    //   return this.$store.state.project.marketList
    // },
    proprietorList () {
      return this.$store.state.market.proprietorList
    },
    userList () {
      return this.$store.state.market.userList
    },
    ...mapGetters(['projectTypeList'])
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'project_modal' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      marketList: [],
      projectManagerList: [],
      businessManagerList: []
    }
  },
  methods: {
    initSelectList () {
      getMarketsList({ paging: false, status: 'MARKET_STATUS_02' }).then(res => {
        if (res.status === 0) {
          this.marketList = res.data
        }
      })
      getUserList({ paging: false, roleId: 107 }).then(res => {
        if (res.status === 0) {
          this.projectManagerList = res.data
        }
      })
      getUserList({ paging: false, roleId: 108 }).then(res => {
        if (res.status === 0) {
          this.businessManagerList = res.data
        }
      })
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initSelectList()

        this.$nextTick(() => {
          this.form.setFieldsValue({ progress: 1 })
        })
        if (this.type === this.$sysInfo.MODAL_MODIFY) {
          this.setModelInfo()
        }
      }
    },
    setModelInfo () {
      const model = {
        name: this.model.name,
        shortName: this.model.shortName,
        proprietorId: this.model.proprietorId,
        projectManager: this.model.projectManager,
        businessManager: this.model.businessManager,
        winningTime: moment(this.model.winningTime),
        winningPrice: this.model.winningPrice,
        type: this.model.type,
        progress: this.model.progress
      }
      if (this.model.marketId) {
        model.marketId = this.model.marketId
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(model)
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }
          params.winningTime = moment(params.winningTime).format('YYYY-MM-DD')
          if (this.type === this.$sysInfo.MODAL_ADD) {
            insertProject(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id
            updateProject(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    marketChange (val) {
      if (val) {
        if (this.type === this.$sysInfo.MODAL_ADD) {
          this.$confirm({
            title: '是否同步商机信息?',
            onOk: (e) => {
              this.marketList.map(item => {
                if (item.id === val) {
                  console.log(item, '市场信息')
                  this.form.setFieldsValue({
                    name: item.name,
                    proprietorId: item.proprietorId,
                    winningPrice: item.winningPrice,
                    winningTime: item.winningTime ? moment(item.winningTime) : undefined
                  })
                }
              })
              e()
            },
            onCancel () {}
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.downloadList {
  margin-top: 10px;
  list-style: none;
  li {
    margin: 10px;
  }
}
</style>
